
import { calculateBMI } from "@/lib/fitness-calculations";

export const calculateMetrics = (
  currentWeight: string | undefined,
  currentWaist: string | undefined,
  currentHip: string | undefined,
  selectedStudent: any,
  previousAssessment: any
) => {
  const weight = currentWeight ? parseFloat(currentWeight) : null;
  const waist = currentWaist ? parseFloat(currentWaist) : null;
  const hip = currentHip ? parseFloat(currentHip) : null;

  const bmi = weight && selectedStudent?.height 
    ? calculateBMI(weight, selectedStudent.height)
    : null;

  const whr = waist && hip ? (waist / hip).toFixed(2) : null;

  const weightDiff = weight && previousAssessment?.weight
    ? (weight - previousAssessment.weight).toFixed(1)
    : null;

  return { bmi, whr, weightDiff };
};
